import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteEmailLandingComponent } from './pages/quote-email-landing/quote-email-landing.component';
import { QuoteEmailUpdateComponent } from './pages/quote-email-update/quote-email-update.component';
import { EmailLandingRoutingModule } from './email-landing-routing';
import { LoadingComponent } from './components/loading/loading.component';
import { QuoteEmailLandingService } from './services/quote-email-landing.service';

@NgModule({
  declarations: [QuoteEmailLandingComponent, QuoteEmailUpdateComponent, LoadingComponent],
  imports: [CommonModule, EmailLandingRoutingModule],
  providers: [QuoteEmailLandingService]
})
export class EmailLandingModule {}
